import React from 'react';
import PropTypes from 'prop-types';

import {
  Link,
  Typography,
}                                   from '@material-ui/core';

import { fmtS3ConsoleLink }         from '../../utils/formatters';

const BucketRefWidget = (props) => {
  const { variant, label, url, linked } = props;
  return(
    <Typography variant={variant} color="textSecondary">
      {linked?
        <Link
          href={url} target="_blank" rel="noopener noreferrer">
            {label}
        </Link>
        :
        {label}
      }
    </Typography>
  );
};

export function fmtBucketRef(value) {
  return(<BucketRef value={value}/>);
}

export default function BucketRef(props) {
  const { value, variant, linked, truncate } = props;

  const bucketName=value;
  const bucketConsoleUrl=fmtS3ConsoleLink(value);

  let bucketDisplayName=bucketName.substring(0,truncate);
  if (bucketName!==bucketDisplayName) {
    bucketDisplayName+="...";
  }
  
  return (
    <BucketRefWidget 
      variant={variant} 
      label={bucketDisplayName} 
      url={bucketConsoleUrl} linked={linked}/>
  );
}

BucketRef.propTypes = {
  value: PropTypes.string.isRequired,
  variant: PropTypes.string.isRequired,
  linked: PropTypes.bool.isRequired,
  truncate: PropTypes.number.isRequired,
};

BucketRef.defaultProps = {
  variant: 'inherit',
  linked: true,
  truncate: 15
};
